<div class="wrapper container-fluid p-0 m-0">
    <div class="row justify-content-center p-0 m-0 flex-layout">
        <div class="col-md-4 align-self-center left-col">
            <img class="credit-logo" alt="Central Credit Corp Logo" src="./assets/logo.png" />
            <!-- <img class="credit-logo" src="./assets/login-graphic.png" /> -->
            
        
        </div>
        <div class="col-md-8 right-col d-flex flex-column justify-content-center">
            <div class="row justify-content-center m-0 p-0 ">
                <div class="col-xl-8 col-l-8 col-md-12 col-sm-12 col-xs-12 ">
                    
                    <form class="form-horizontal" [formGroup]="loginForm" (ngSubmit)="signIn()">
                        <!-- <div>
                            <label class="form-label">Contectate a:</label><br/>
                            <input type="radio" class="btn-check" name="options" id="option1" autocomplete="off" value="insurance" [(ngModel)]="selectedService" [ngModelOptions]="{standalone: true}">
                            <label class="btn btn-secondary select-service" for="option1">Seguros</label>

                            <input type="radio" class="btn-check" name="options" id="option2" autocomplete="off" value="loans" [(ngModel)]="selectedService" [ngModelOptions]="{standalone: true}">
                            <label class="btn btn-secondary" for="option2" >Préstamos</label>
                        </div> -->
                        <label class="form-label mt-3">Username</label>
                        <div class="input-group flex-nowrap mb-3">
                            <img class="input-group-text" width="35" src="./assets/icons/user.svg" />
                            <input type="text" class="form-control" formControlName="prod_user_name"
                                id="codigo-perador">
                        </div>
                        
                        <label class="form-label">Contraseña</label>
                        <div class="input-group flex-nowrap">
                            <img class="input-group-text" src="./assets/icons/lock-fill.svg" />
                            <input type="password" class="form-control" formControlName="prod_password"
                                id="password">
                        </div>

                        

                        <button type="submit" class="btn btn-primary mt-5 login-btn" >Login</button>
                        <p class="err-msg" *ngIf="error">{{ msg }}</p>

                        <app-forgot-password></app-forgot-password>
                    </form>
                    
                    
                    
                </div>
            </div>
        </div>
    </div>

</div>

<app-new-password [userData]="userData"></app-new-password>